import { Injectable, signal } from '@angular/core';


export enum StepperSubmitButton {
  Personal = 0,
  CompleteDetails = 1,
  Activate = 3,
  Error = -1,
  TriggerClick = -2,
}

@Injectable({
  providedIn: 'root',
})
export class RegistrationSidebarService {
  public readonly selectedIndex = signal<StepperSubmitButton>(StepperSubmitButton.Personal);
  public readonly hasValidEmailAddress = signal(false);
  public readonly shouldCompleteProfile = signal<boolean>(false);

  public readonly continueButtonLabel = signal<string>('');
  public readonly continueButtonLoading = signal<boolean>(false);
  public readonly continueButtonDisabled = signal<boolean>(true);
  public readonly continueButtonOnClicked = signal<StepperSubmitButton>(null);

}
